import React from "react";
import { useSelector } from "react-redux";
import TheHeader from "../comm/inCar/TheHeader";
import TheNav from "../comm/inCar/TheNav";
import TheFooter from "../comm/inCar/TheFooter";
import ApiHelper from "src/utils/api/api_helper";
import {
  CContainer,
  CCardBody,
  CListGroup,
  CListGroupItem,
} from "@coreui/react";

const InfoPage = () => {
  const state = useSelector((state) => state.main);
  const [docs, setDocs] = React.useState([]);
  const param = { taskNo: state.taskNo };
  param.crerYn = state.crerYn;

  React.useEffect(() => {
    ApiHelper.request(
      ApiHelper.methods.post,
      "/cust/request/sbmsDocList",
      param
    )
    .then(async ({ data }) => {
      if (data.status === "SUCCESS") {
        let result = data.data;
        await setDocs(result);
      }
    })
    .catch((err) => {
      console.error(err);
    });
  }, []);

  return (
    <>
      <TheHeader />
      <div className="c-main">
        <TheNav step={state.step} />
        <CContainer>
          <h5>
            <b>
              보험사별 위촉서류 작성을 위해 준비할 내용입니다.
            </b>
          </h5>
          <h6 className="reUploadText">
              <b>* 업로드 후 3개월이 초과된 파일은 재업로드가 필요하니 확인 후 진행해주세요.</b>
          </h6>
        </CContainer>
        <CCardBody className="bottom-card-body">
          <CListGroup>
            {docs.length
              ? docs.map((doc) => {
                return (
                  <CListGroupItem
                    className="infoListItem"
                    key={doc.SBMS_DOC_NO}
                  >
                    {((doc.SBMS_DOC_NO == '45' || doc.SBMS_DOC_NO == '50' || doc.SBMS_DOC_NO == '55') && state.crerYn == '1') ?
                      <>
                      교육수료증(1년 이내 보험연수원 수료증)<br/>- 경력자등록or보수<br/>※ 협회등록 365일 미만자 신규등록 교육
                      </>
                      : ((doc.SBMS_DOC_NO == '45' || doc.SBMS_DOC_NO == '50' || doc.SBMS_DOC_NO == '55') && state.crerYn == '0') ?
                      <>1년 이내 보험연수원 신규등록 <b>교육수료증</b></>
                      : <>{doc.SBMS_DOC_NM}</>
                    }
                  </CListGroupItem>
                );
              })
              : <CListGroupItem
                  className="infoListItem"
                >
                  해당업무에는 별도로 준비할 내용이 없습니다.
                </CListGroupItem>}
          </CListGroup>
        </CCardBody>
        {state.crerYn == '1' &&
          <>
            <div>
              <a href="http://www.e-cleanins.or.kr" style={{fontSize: "1rem"}}>http://www.e-cleanins.or.kr</a>
            </div>
            <img src="/e_clean_QR.png" alt="logo" width="150px" style={{marginTop: "3rem", marginBottom: "5rem"}}/>
          </>
        }
      </div>
      <TheFooter step={state.step} />
    </>
  );
};

export default InfoPage;
